// @ts-expect-error https://github.com/fontsource/fontsource/issues/1038
import "@fontsource-variable/domine"
// @ts-expect-error https://github.com/fontsource/fontsource/issues/1038
import "@fontsource-variable/mulish"
import { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import { routeTree } from "./routeTree.gen"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import * as Sentry from "@sentry/react"
import "react-day-picker/style.css"
import {
  MAINTENANCE_MODE,
  MaintenanceScreen,
  configureApiClient,
  setupSentryUserIdSync,
} from "toptaal-shared"
import { useAuthStore } from "./stores/useAuthStore"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
})

configureApiClient({
  authStore: {
    getToken() {
      return useAuthStore.getState().getToken()
    },
    getRefreshToken() {
      return useAuthStore.getState().getRefreshToken()
    },
    setToken: (token: string) => {
      useAuthStore.getState().setToken(token)
    },
    setRefreshToken: (refreshToken: string) => {
      useAuthStore.getState().setRefreshToken(refreshToken)
    },
  },
  apiUrl: import.meta.env.VITE_API_URL,
  onLogout: () => {
    useAuthStore.getState().logout()
    Promise.resolve().then(() => {
      queryClient.clear()
    })
    router.navigate({ to: "/login", replace: true })
  },
})

export const router = createRouter({ routeTree, context: { queryClient } })

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  beforeSend(event) {
    event.tags = {
      ...event.tags,
      application: "mijn-toptaal-app",
    }

    return event
  },

  tracesSampleRate: 1.0,
})

setupSentryUserIdSync({
  authStore: useAuthStore,
  setSentryUser: Sentry.setUser,
  getUserId: (user) => user.baseUserId,
})

const rootElement = document.getElementById("root")!

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {MAINTENANCE_MODE ? (
          <MaintenanceScreen />
        ) : (
          <RouterProvider
            router={router}
            context={{
              queryClient,
            }}
          />
        )}
      </QueryClientProvider>
    </StrictMode>,
  )
}
